import { Roles } from 'src/shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const payrollPaths = {
	default: '',
	root: 'payroll',
	detail: ':id',
	calendar: 'calendar',
};

export const payrollFragments = {
	default: [payrollPaths.default],
	root: [payrollPaths.default, payrollPaths.root],
	calendar: [payrollPaths.default, payrollPaths.root, payrollPaths.calendar],
	detail: (id: number) => [payrollPaths.default, payrollPaths.root, id],
};

export const payrollDefaultAuthRoles = [Roles.Admin, Roles.Payroll];

export const payrollDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: payrollDefaultAuthRoles },
};
